import React from 'react';

const Icon = () => {
    return (
        <svg width="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                opacity="0.15"
                d="M0 15.9C0 10.3938 0 7.64071 1.05455 5.53021C2.02249 3.59308 3.59308 2.02249 5.53021 1.05455C7.64071 0 10.3938 0 15.9 0H24.1C29.6062 0 32.3593 0 34.4698 1.05455C36.4069 2.02249 37.9775 3.59308 38.9454 5.53021C40 7.64071 40 10.3938 40 15.9V24.1C40 29.6062 40 32.3593 38.9454 34.4698C37.9775 36.4069 36.4069 37.9775 34.4698 38.9454C32.3593 40 29.6062 40 24.1 40H15.9C10.3938 40 7.64071 40 5.53021 38.9454C3.59308 37.9775 2.02249 36.4069 1.05455 34.4698C0 32.3593 0 29.6062 0 24.1V15.9Z"
                fill="#33CF90"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.6987 28C27.523 28 29 26.5418 29 24.7428V22.1508C27.7935 22.1508 26.8205 21.1909 26.8205 20.0014C26.8205 18.8111 27.7935 17.852 29 17.852L28.9981 15.2572C28.9981 13.4582 27.5211 12 25.6977 12H14.3023C12.4789 12 11.001 13.4582 11.001 15.2572L11 17.9356C12.2055 17.9356 13.1785 18.8111 13.1785 20.0014C13.1785 21.1909 12.2055 22.1508 11 22.1508V24.7428C11 26.5418 12.477 28 14.3003 28H25.6987Z"
                stroke="#33CF90"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.9986 21.7L21.6916 22.5784C21.8502 22.66 22.036 22.5275 22.0059 22.3538L21.6819 20.4924L23.0528 19.1762C23.1812 19.0524 23.1102 18.8383 22.9331 18.8124L21.0397 18.5407L20.1923 16.8473C20.1134 16.6889 19.8848 16.6889 19.805 16.8473L18.9575 18.5407L17.0651 18.8124C16.888 18.8383 16.817 19.0524 16.9454 19.1762L18.3154 20.4924L17.9914 22.3538C17.9612 22.5275 18.1471 22.66 18.3057 22.5784L19.9986 21.7Z"
                stroke="#33CF90"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Icon;
